/**
 * /tenants/$slug/passkey-intelligence — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchPasskeyOverview } from "@/features/passkey-intelligence/queries";
import { queryKeys } from "@/lib/query-keys";
import { PasskeyIntelligencePage } from "@/features/passkey-intelligence/pages/passkey-intelligence-page";

export const Route = createFileRoute("/_authed/tenants/$slug/passkey-intelligence/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.passkeyIntelligence.overview(context.tenant.id),
      queryFn: () => fetchPasskeyOverview(context.tenant.id),
    }),
  component: PasskeyIntelligencePage,
});
